import React from "react";
import { useSeriesShowContext } from "../SeriesShowApp";
import { formatWholeCents } from "../../../shared/teamCurrencyFormatting";
import { CapacityMeter } from '@opendate-app/setlist';

// The card already prints the value and "of N across series", so the meter is
// the bar alone.
const ProgressBar = ({ sold, capacity }) => (
  <CapacityMeter size="sm" label="none" showNumbers={false} unit="tickets" taken={sold} capacity={capacity} />
);

const KpiCards = () => {
  const { series, listedAsCollection } = useSeriesShowContext();
  const noun = listedAsCollection ? "collection" : "series";
  const stats = series.summary_stats;
  const fmtCurrency = (cents) => formatWholeCents(cents, series.base_currency_symbol);
  const schedule = series.schedule;
  const { events_in_series, tickets_sold, gross_revenue, avg_capacity_sold } = stats;

  const weekDeltaCents = gross_revenue.week_delta_cents || 0;
  const deltaPositive = weekDeltaCents >= 0;

  const bestEvent = avg_capacity_sold.best_event_id && schedule
    ? schedule.find(ev => ev.calendar_event_id === avg_capacity_sold.best_event_id)
    : null;
  const bestDate = bestEvent
    ? new Date(bestEvent.start_time).toLocaleDateString("en-US", { month: "short", day: "numeric" })
    : null;
  const bestIsSoldOut = bestEvent && bestEvent.capacity > 0 && bestEvent.tickets_sold >= bestEvent.capacity;

  return (
    <div className="series-kpi-grid">
      <div className="series-kpi-card">
        <div className="series-kpi-label">Events in {noun}</div>
        <div className="series-kpi-value">{events_in_series.total}</div>
        <div className="series-kpi-sub">
          {events_in_series.upcoming} upcoming &bull; {events_in_series.past} past
        </div>
      </div>

      <div className="series-kpi-card">
        <div className="series-kpi-label">Tickets sold</div>
        <div className="series-kpi-value">{tickets_sold.sold.toLocaleString()}</div>
        <ProgressBar sold={tickets_sold.sold} capacity={tickets_sold.capacity} />
        <div className="series-kpi-sub">of <strong>{tickets_sold.capacity.toLocaleString()}</strong> across {noun}</div>
      </div>

      <div className="series-kpi-card">
        <div className="series-kpi-label">Gross ticket revenue</div>
        <div className="series-kpi-value">{fmtCurrency(gross_revenue.cents)}</div>
        <div className="series-kpi-sub d-flex align-items-center series-kpi-delta">
          <i
            className={`${deltaPositive ? "fa fa-arrow-up" : "fa fa-arrow-down"} series-kpi-delta-icon`}
            style={{ color: deltaPositive ? "var(--sl-text-success)" : "var(--sl-text-error)" }}
          />
          <span className="series-kpi-delta-value" style={{ color: deltaPositive ? "var(--sl-text-success)" : "var(--sl-text-error)" }}>
            {fmtCurrency(Math.abs(weekDeltaCents))}
          </span>
          <span className="series-kpi-delta-label">this week</span>
        </div>
      </div>

      <div className="series-kpi-card">
        <div className="series-kpi-label">Avg capacity sold</div>
        <div className="series-kpi-value">{Math.round((avg_capacity_sold.pct || 0) * 100)}%</div>
        {bestDate && (
          <div className="series-kpi-sub">
            Best night: {bestDate}{bestIsSoldOut ? " (sold out)" : ""}
          </div>
        )}
      </div>
    </div>
  );
};

export default KpiCards;
